import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import DownloadController from '../../controller/download.controller';
import download from '../../assets/img/icons/download.svg';
import pen from '../../assets/img/icons/pen.svg';
import GieCard from "../GIECard/GieCard";
import GIESvgIcon from "../GIEIcon/GIESvgIcon";
import './List.css';

export default class GIEList extends React.Component<any, any> {
  downloadController: DownloadController = new DownloadController();

  constructor(props) {
    super(props);
    this.state = {
      dense: true,
      secondary: false,
      data: [],
      notice: '',
    }
  }

  getTypeOfWorkOrder = (workOrderType) => {
    let workOrder = '';
    switch (workOrderType) {
      case 'invoice': {
        workOrder = 'Facture'
        break;
      }
      case 'contract': {
        workOrder = 'Contrat'
        break;
      }
    }
    return workOrder;
  }

  getLibelle = (item) => {
    let type = '';

    switch (this.props.type) {
      case 'invoice': {
        type = (item.number.substring(0, 1) === 'A') ? 'Avoir' : 'Facture';
        break;
      }
      case 'quotation': {
        type = 'Devis'
        break;
      }
      case 'workOrder': {
        type = "Intervention"
        break;
      }
      case 'outstanding': {
        type = 'Encours';
        break;
      }
    }
    type = type + ' n° - ' + item.number + ' - ' + this.getTitle(item) + ' - ' + item.date
    if (this.props.type !== 'workOrder') {
      type = type + ' - Montant : ' + item.amount + '€ '
    } else {
      type = type + this.getTypeOfWorkOrder(item.type)
    }
    return type;
  }

  getTitle = (item) => {
    let title = item.title;
    if (this.props.type === 'invoice' && title.length === 0) {
      title = 'CONTRAT'
    }
    return title;
  }

  downloadFile = (item, data) => {
    const fileName = item.number + '.pdf'
    const linkSource = `data:application/pdf;base64,${data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  download(item: any) {
    if (item.visible === true) {
      const request = {
        documentNo: item.number,
        custommerNo: item.customerNo,
        docType: item.downloadType,
      }
      this.downloadController.downloadDoc(request).then((data: string) => {
        this.downloadFile(item, data)
      }).catch(err => {
        console.log(err)
      })
    } else {
      console.log('no document to download')
    }
  }

  sign = () => {
    console.log('sign')
  }

  render() {
    return (
      <div className="content">
        <GieCard width="100%" height="100%">
          {!this.props.data.length ? (
              <div className="d-flex justify-content-center align-items-center my-4">
                <span className="fs-5">{this.props.noData}</span>
              </div>
            ) :
            (<table className="w-100 table table-hover">
                <tbody>
                {this.props.data.map((item, index) => (
                  <tr>
                    <td className="col-libelle">{this.getLibelle(item)}</td>
                    <td className="col-actions">
                      <div className="d-flex align-items-center justify-content-end gap-2">
                        {item.visible && <>
                            <Tooltip title="Télécharger">
                                <GIESvgIcon className="cursor-pointer" icon={download}
                                            onClick={() => this.download(item)}/>
                            </Tooltip>
                        </>}
                        {item.signed === false &&
                            <Tooltip title="Signer votre document" aria-label="Signer votre document">
                                <GIESvgIcon className="cursor-pointer" icon={pen} onClick={this.sign}/>
                            </Tooltip>}
                      </div>
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            )}
          <div>
            {this.props.children}
          </div>
        </GieCard>
      </div>
    )

  }
}
